window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.note = function (parent, shared) {
    const _thisField = parent;
    const _shared = shared;
    let _validatedControlWrapper = null;
    let _control = null;
    let _validationCanvas = null;

    {
        // Init
        _thisField.validation = {
            required: _thisField.settings.required ?? false,
            maxLength: _thisField.settings.data.maxlength ?? null,
            dirty: false
        };
    }

    const render = function (fieldGroup) {
        _control = document.createElement('textarea');
        _control.classList.add(window.mcb.forms.constants.fields.controlClass);
        _control.classList.add(window.mcb.forms.constants.fields.uiInput);
        _control.id = _thisField.fieldValueControlId;
        _control.name = _thisField.alias;

        if (_thisField.settings.placeholder !== null) {
            _control.placeholder = _thisField.settings.placeholder;
        }

        if (_thisField.settings.defaultValue !== null) {
            _control.value = _thisField.settings.defaultValue;
            _control.dataset.dirty = true;
        }

        if (_thisField.validation.maxLength !== null) {
            _control.dataset.maxLength = _thisField.validation.maxLength;
        }

        if (_thisField.settings.data.rows !== null) {
            _control.rows = _thisField.settings.data.rows;
        }

        _control.addEventListener('focus', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(_control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('paste', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('keyup', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('blur', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, true, true);
        });

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(_control);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const getValue = function (allowValueFormatting = false) {
        window.mcb.forms.validation.clearValidationResults(_validationCanvas);

        if (_control === null) {
            throw new Error("Control is not initialized");
        }

        if (document.getElementById(_control.id) === null) {
            throw new Error("Control has been removed from DOM");
        }

        if (_control.offsetParent === null) {
            // Field is not visible
            return undefined;
        }

        let value = _control.value;

        const validation = new window.mcb.forms.validation.ValidationResult(true);
        if (_thisField.validation.required === true) {
            validation.aggregate(window.mcb.forms.validation.validateRequired(_thisField.alias, value));
        }

        if (validation.isValid()) {
            if (_thisField.validation.maxLength !== null) {
                validation.aggregate(window.mcb.forms.validation.validateMaxLength(_thisField.alias, value, _thisField.validation.maxLength));
            }
        }

        validation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (validation.isValid()) {
            return value;
        }

        return null;
    };

    const setValue = function (value) {
        _control.value = value;
        return true;
    }

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
